function debounce (fn, wait, immediate = false) {
  let timer = 0
  let startTimeStamp = 0 // 开始时间戳
  let context // 上下文 （this指向）
  let args // 参数

  let run = timerInterval => {
    timer = setTimeout(() => {
      let now = new Date().getTime() // 获取当前时间戳
      let interval = now - startTimeStamp // 进入延时器后，与上一个时间戳的间隔
      if (interval < timerInterval) {
        startTimeStamp = now // 更新局部作用域的开始时间戳
        run(wait - interval) // 延迟时间为：我规定的延迟时间 -
      } else {
        if (!immediate) fn.apply(context, args) // 如果立即执行函数为否，则执行函数
        clearTimeout(timer)
        timer = null
      }
    }, timerInterval)
  }

  return function () {
    context = this
    args = arguments
    let now = new Date().getTime()
    startTimeStamp = now

    if (!timer) {
      if (immediate) fn.apply(context, args)
      run(wait)
    }
  }
}
function getItalic (name) {
  let index = name.indexOf('sp.')
  let italicName = ''
  let notItalicName = ''
  if (name === 'Chlamydomonas reinhardtii-2') {
    let index = name.indexOf('-')
    italicName = name.substring(0, index)
    notItalicName = name.substring(index)
    return { italicName, notItalicName }
  }
  if (index !== -1) {
    italicName = name.substring(0, index)
    notItalicName = name.substring(index)
  } else {
    let list = name.split(' ')
    let list1 = []
    list1 = list.splice(0, 2)
    italicName = list1.join(' ')
    if (list.length !== 0) {
      italicName = italicName + '\xa0'
      notItalicName = list.join(' ')
    }
  }
  return { italicName, notItalicName }
}
export default { debounce, getItalic }



// WEBPACK FOOTER //
// ./src/utils/index.js